import moment from "moment";
import C from "action-types";
import { browserHistory } from "browser-history";
import { makeFetchCreator } from "actions/fetch";
import { errorMessage } from "actions/message";
import { post, put } from "utils/api";
import { transformUiQuery } from "utils/query";
import omit from "lodash/omit";

export const EXPORTS_START_FETCH_INTERVAL = "EXPORTS_START_FETCH_INTERVAL";
export const startExportFetchInterval = (id, delayTime = 15000 /* ms */) => ({
  type: EXPORTS_START_FETCH_INTERVAL,
  payload: {
    id,
    delayTime
  }
});

export const EXPORTS_END_FETCH_INTERVAL = "EXPORTS_END_FETCH_INTERVAL";
export const endExportFetchInterval = () => ({
  type: EXPORTS_END_FETCH_INTERVAL
});

export const EXPORTS_LAST_UPDATED = "EXPORTS_LAST_UPDATED";
export const exportsLastUpdated = date => ({
  type: EXPORTS_LAST_UPDATED,
  payload: {
    time: moment(date).format("MMM D, h:mm:ss")
  }
});

const postExportAccessLogs = makeFetchCreator({
  url: () => `tools/access`,
  baseType: C.EXPORTS.POST,
  method: post
});

export const addExportAccessLogs =
  ({ payload }) =>
  dispatch =>
    dispatch(
      postExportAccessLogs({
        payload: {
          payload
        }
      })
    )
      .then(() => {
        browserHistory.push("/exports");
      })
      .catch(() => {
        dispatch(errorMessage("Something went wrong"));
      });

export const exportPatientsReport =
  (query, columnsToExport = []) =>
  async dispatch => {
    try {
      await put("patients/export", {
        ...omit(transformUiQuery(query), "pagination"),
        columnsToExport
      });
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export patient report."));
    }
  };

  export const exportPatientTasks =
  (query, columnsToExport = []) =>
  async dispatch => {
    try {
      await put("tasks/patient/export", {
        ...omit(transformUiQuery(query), "pagination"),
        columnsToExport
      });
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export patient tasks."));
    }
  };

  export const exportOrderTasks =
  (query, columnsToExport = []) =>
  async dispatch => {
    try {
      await put("tasks/orders/export", {
        ...omit(transformUiQuery(query), "pagination"),
        columnsToExport
      });
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export order tasks."));
    }
  };

export const exportFirstTimeRegistration =
  (query, columnsToExport = []) =>
  async dispatch => {
    try {
      await post("first-time-registration-dashboard/export", {
        ...omit(transformUiQuery(query), "pagination"),
        columnsToExport
      });
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export first time registration registers."));
    }
  };

  export const exportAllTasks =
  (query, columnsToExport = []) =>
  async dispatch => {
    try {
      await put("tasks/all/export", {
        ...omit(transformUiQuery(query), "pagination"),
        columnsToExport
      });
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export all tasks."));
    }
  };

  export const exportFormReport =
  (data) =>
  async dispatch => {
    try {
      await put("forms/export", data);
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to generate report"));
    }
  };

export const exportIncompleteOrderTracking =
  (query) =>
  async dispatch => {
    try {
      // Transform filters to filter_by array format expected by this endpoint
      const filterMap = {};
      if (query.filters) {
        Object.entries(query.filters).forEach(([key, values]) => {
          if (Array.isArray(values) && values.length > 0) {
            const validValues = values.filter(v => v);
            if (validValues.length > 0) {
              filterMap[key] = validValues.join("^");
            }
          }
        });
      }

      const filterBy = Object.entries(filterMap).map(([key, value]) => ({
        by: key,
        value: value
      }));

      const payload = {
        search_for_array: [],
        pagination: query.pagination,
        sort: query.sort,
        filter_by: filterBy
      };

      await put("incomplete_order_tracking/export", payload);
      browserHistory.push("/exports");
    } catch (error) {
      dispatch(errorMessage("Failed to export orders."));
    }
  };


